import axios from "axios";
import Web3 from "web3";
import DepositToVaultException from "../../errors/DepositToVaultException";
import InitWithdrawException from "../../errors/InitWithdrawException";
import Decimal from "decimal.js";
import moment from "moment";
import helpers from "../../helpers";

const walletConnectTimeOut = 60000;
const walletConnectTimeOutMessage = "Transaction time out, please log out, refresh page and reconnect again to wallet provider.";
const walletConnectTrxNoticeMessage = "Please check the transaction request pop up on selected wallet provider app/site.";

const state = () => ({
    vaults: [],
    network: null, //wss network url
    ui_abi: null,
    syn_abi: null,
    showNetworkAlert: false,
    env: {} //store config/vault.php as json
});

const getters = {
    getShowNetworkAlert: state => state.showNetworkAlert,

    getAllNetwork(state) {
        const arrayKey = state.env.network;
        if (!arrayKey) return [];

        const networks = [];
        for (const key in arrayKey) {
            const element = arrayKey[key];
            networks.push({
                name: key,
                value: element.chain,
                text: element.name,
                url: element.url,
                rpc: element.rpc,
                token: element.token ?? key
            });
        }
        return networks;
    },

    getAvailableNetwork(state, getters, rootState, rootGetters) {
        if (!rootState.wallet.chainId) {
            // return empty array if no network selected
            return [];
        }

        const arrayKey = state.env.network;
        if (!arrayKey) return [];

        const networks = [];
        for (const key in arrayKey) {
            const element = arrayKey[key];
            if (element.chain != rootState.wallet.chainId) {
                networks.push({
                    name: key,
                    value: element.chain,
                    text: element.name,
                    url: element.url,
                    rpc: element.rpc,
                    token: element.token ?? key
                });
            }
        }
        return networks;
    }
};

/// web3.eth.getTransactionReceipt("0x62720366ef403c9891e2bfbd5358ee3c8a57b11");

const actions = {
    init(context, data) {
        context.commit("setVaultEnv", data);
        context.commit("setUiAbi", JSON.parse(data.ui_abi));
        context.commit("setSynAbi", JSON.parse(data.syn_abi));
    },

    isAllowedNetwork({ getters }, chainId) {
        let allowedNetwork = getters.getAllNetwork;
        for (const network of allowedNetwork) {
            if (chainId == network.value) {
                return true;
            }
        }
        return false;
    },

    async checkAllowance(context, { token, contractAddress }) {
        //not allowed if fields are missing
        if (
            context.rootState.wallet.address === null ||
            contractAddress === null ||
            !context.rootState.wallet.walletProvider
        )
            return "0";

        const tokenContract = new context.rootState.wallet.activeWeb3.eth.Contract(
            token.abi,
            token.contract
        );

        let allowance = await tokenContract.methods
            .allowance(context.rootState.wallet.address, contractAddress)
            .call({ from: context.rootState.wallet.address });
        return allowance;
    },

    getSingleVault(context, contractAddress) {
        return context.state.vaults.filter(vault => {
            return vault.contract_address === contractAddress;
        });
    },

    async getAllVaults(context, chainId) {
        let hasWallet = localStorage.hasWallet === "true";
        if (!context.rootState.wallet.walletProvider || hasWallet == false || !hasWallet)
            chainId = "all";
        else chainId = context.rootState.wallet.chainId;
        return axios
            .get(`/api/vaults/${chainId}/get-chain-id`)
            .then(async res => {
                let vaults = res.data.data;
                const checkedVault = [];
                for (let i = 0; i < vaults.length; i++) {
                    let vault = vaults[i];

                    if (
                        vault.is_il === 1 &&
                        context.rootState.wallet.walletProvider
                    ) {
                        //check current mode from smart contract
                        vault = await this.dispatch("il/checkVaultType", {
                            vault: vault
                        });
                    }

                    checkedVault.push(vault);
                }

                this.commit("vaults/setVaults", checkedVault);
                return vaults;
            });
    },

    async generateGasFee(context, network) {
        try {
            if (network == "matic" || network == "ftm") {
                const result = await context.rootState.wallet.activeWeb3.eth.getGasPrice();
                if (network == "matic") {
                    if (result > 31000000000)
                        return {
                            gasPrice: +result,
                            maxFeePerGas: 2 * result,
                            maxPriorityFeePerGas: 31000000000
                        };
                    else return { gasPrice: 31000000000 };
                }
                else {
                    if (result > 1500000000000)
                        return {
                            gasPrice: +result,
                            maxFeePerGas: +result,
                            maxPriorityFeePerGas: +result
                        };
                    else
                        return {
                            gasPrice: 1500000000000,
                            maxFeePerGas: 1500000000000,
                            maxPriorityFeePerGas: 1300000000000
                        };
                }
            } else return {};
        } catch (error) {
            console.log(error);
            return {};
        }
    },
    async GasLimitApproval(contaxt, network){
        try{
            if(network == 'boba'){
                return { gas: "500000"};
            }else{
                return {};
            }
        } catch(error){
            console.log(error);
            return {};
        }
    },
    async approve(context, { vault_contract, token, type }) {
        try {
            const tokenContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                token.abi,
                token.contract
            );
//            const gasLimit = await context.dispatch("GasLimitApproval", context.rootState.wallet.selectedNetwork);

            let params = {
                from: context.rootState.wallet.address,
                ...(type !== undefined && { type: type })
            };
//            params = { ...params, ...gasLimit };

            const gasFeeParam =  await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
            params = { ...params, ...gasFeeParam };

            // special case for walletconnect empty response
            if (context.rootState.wallet.walletProvider == "walletconnect") {
                let promise = new Promise(function(resolve, reject) {
                    setTimeout(() => {
                        reject(new Error(walletConnectTimeOutMessage));
                    }, walletConnectTimeOut);

                    Vue.default.toasted.info(
                        walletConnectTrxNoticeMessage,
                        { duration: 2500 }
                    );

                    tokenContract.methods
                        .approve(
                            vault_contract,
                            context.rootState.wallet.activeWeb3.utils.toWei(
                                context.rootState.wallet.activeWeb3.utils.toBN(1e20)
                            )
                        )
                        .send(params)
                        .on("transactionHash", async (txHash) => {
                            if(txHash) {
                                while (true) {
                                    const trx = await context.rootState.wallet.activeWeb3.eth.getTransaction(txHash);
                                    // console.log(trx);
                                    if(trx && trx.blockNumber) {
                                        resolve(trx.blockNumber);
                                        break;
                                    }
                                }
                            }
                        })
                        .on("receipt", async (receipt) => {
                            // console.log(receipt);
                            resolve(receipt.blockNumber);
                        })
                        .on("error", async (error, receipt) => {
                            // console.log(error);
                            reject(error);
                        });
                });
                return promise;
            } else {
                const approve = await tokenContract.methods
                    .approve(
                        vault_contract,
                        context.rootState.wallet.activeWeb3.utils.toWei(
                            context.rootState.wallet.activeWeb3.utils.toBN(1e20)
                        )
                    )
                    .send(params);

                return approve;
            }
        } catch (error) {
            if (error.code) {
                // user denied
                if (error.code !== 4001) {
                    //save some relevant data
                    const payload = {
                        message: error.message,
                        code: error.code ? error.code : null,
                        vault_contract,
                        from: context.rootState.wallet.address,
                        isEIP1559: type === undefined ? true : false,
                        tokenSymbol: token ? token.symbol : null,
                        tokenDecimals: token ? token.decimals : null
                    };

                    await context.dispatch("logError", {
                        payload,
                        action: "APPROVE"
                    });
                }

                if (error.code === -32602) {
                    // let the view handle this error
                    throw error;
                }
            }

            Vue.default.toasted.error("Failed to approve allowance");

            return false;
        }
    },

    async allowInteraction(context, { vault_contract, abiType }) {
        try {
            const vaultContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                window[abiType],
                vault_contract
            );

            let interaction = await vaultContract.methods
                .ALLOW_INTERACTIONS()
                .call();

            return interaction;
        } catch (error) {
            //Vue.default.toasted.error("Failed to get allow interactions status");
            return undefined;
        }
    },

    async doWithdraw(context, { vault_contract, abiType, type }) {
        try {
            const vaultContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                window[abiType],
                vault_contract
            );

            const data = vaultContract.methods.withdraw().encodeABI();

            let interaction = await context.dispatch("allowInteraction", {
                vault_contract,
                abiType
            });
            const gasLimit = helpers.generateGasLimit(context.rootState.wallet.selectedNetwork);
            if (interaction == undefined || interaction == true) {
                let param = {
                    to: vault_contract, // Required except during contract publications.
                    from: context.rootState.wallet.address, // must match user's active address.
                    gas: gasLimit, // customizable by user during MetaMask confirmation.
                    data: data, // Optional, but used for defining smart contract creation and interaction.
                    ...(type !== undefined && { type: type })
                };

                const gasFeeParam =  await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
                param = { ...param, ...gasFeeParam };

                await vaultContract.methods.withdraw().call(param);

                // special case for walletconnect empty response
                if (context.rootState.wallet.walletProvider == "walletconnect") {
                    let promise = new Promise(function(resolve, reject) {
                        setTimeout(() => {
                            reject(new Error(walletConnectTimeOutMessage));
                        }, walletConnectTimeOut);

                        Vue.default.toasted.info(
                            walletConnectTrxNoticeMessage,
                            { duration: 2500 }
                        );

                        vaultContract.methods
                            .withdraw()
                            .send(param)
                            .on("transactionHash", async (txHash) => {
                                if(txHash) {
                                    while (true) {
                                        const trx = await context.rootState.wallet.activeWeb3.eth.getTransaction(txHash);
                                        // console.log(trx);
                                        if(trx && trx.blockNumber) {
                                            resolve(trx.blockNumber);
                                            break;
                                        }
                                    }
                                }
                            })
                            .on("receipt", async (receipt) => {
                                // console.log(receipt);
                                resolve(receipt.blockNumber);
                            })
                            .on("error", async (error, receipt) => {
                                // console.log(error);
                                reject(error);
                            });
                    });
                    return promise;
                } else {
                    const withdrawCall = await vaultContract.methods
                    .withdraw()
                    .send(param);

                    return withdrawCall;
                }
            } else {
                Vue.default.toasted.error(
                    "The vaults are currently closed for auction, and will be open for deposits and withdrawals once the winner deposits the winning premium."
                );
            }
        } catch (error) {
            if (error) {
                // except user denied
                if (error.code !== 4001 || error == undefined) {
                    //save some relevant data
                    const payload = {
                        message: error.message,
                        code: error.code ? error.code : null,
                        vault_contract,
                        abiType: abiType,
                        isEIP1559: type === undefined ? true : false,
                        from: context.rootState.wallet.address
                    };

                    await context.dispatch("logError", {
                        payload,
                        action: "WITHDRAW"
                    });
                }

                if (error.code === -32602) {
                    // let the view handle this error
                    throw error;
                }
            }

            if (error.message.includes("reverted"))
                Vue.default.toasted.error(
                    error.message.split("reverted:")[1].split('"')[0]
                );
            else Vue.default.toasted.error("Error withdrawing from vault");

            return false;
        }
    },

    async initWithdraw(
        context,
        {
            vault_contract,
            amount,
            abiType,
            maxWithdraw,
            token,
            queuedDeposits,
            type
        }
    ) {
        try {
            if (+amount < 0) {
                throw new InitWithdrawException("Invalid withdrawal amount");
            }

            if (+amount > +maxWithdraw) {
                Vue.default.toasted.info(
                    "Warning: You are trying to withdraw more than your deposits.",
                    { duration: 2500 }
                );
            }

            const vaultContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                window[abiType],
                vault_contract
            );
            let interaction = await context.dispatch("allowInteraction", {
                vault_contract,
                abiType
            });
            if (interaction == undefined || interaction == true) {
                let withdrawAmount = "0";
                // FYI cancelWithdraw calls this function and the submitted amount is 0 and token will not be passed in
                if (token !== undefined && +amount > 0) {
                    Decimal.set({
                        precision: 50,
                        toExpPos: 50
                    });
                    const amountInBN = new Decimal(amount).mul(token.decimals);
                    const maxWithdrawInBN = new Decimal(maxWithdraw).mul(
                        token.decimals
                    );

                    //check if there are queuedDeposits
                    if (+queuedDeposits > 0)
                        throw new InitWithdrawException(
                            `You have ${queuedDeposits} ${token.symbol.toUpperCase()} pending deposit. Please cancel deposit first before initiating withdrawal`
                        );

                    // check withdraw amount exceeds max withdraw
                    // if (amountInBN.gt(maxWithdrawInBN)) {
                    //     throw new InitWithdrawException('Withdrawal amount exceeds your deposits for this vault');
                    // }

                    // const amountInBN2 = helpers.toBaseUnit(amount.toString(), decimals, BN);
                    withdrawAmount = amountInBN.toString();
                }

                const data = vaultContract.methods
                    .initWithdraw(withdrawAmount)
                    .encodeABI();

                const gasLimit = helpers.generateGasLimit(context.rootState.wallet.selectedNetwork);
                let param = {
                    to: vault_contract, // Required except during contract publications.
                    from: context.rootState.wallet.address, // must match user's active address.
                    gas: gasLimit, // customizable by user during MetaMask confirmation.
                    data: data, // Optional, but used for defining smart contract creation and interaction.
                    ...(type !== undefined && { type: type })
                };

                const gasFeeParam =  await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
                param = { ...param, ...gasFeeParam };

                await vaultContract.methods
                    .initWithdraw(withdrawAmount)
                    .call(param);

                // special case for walletconnect empty response
                if (context.rootState.wallet.walletProvider == "walletconnect") {
                    let promise = new Promise(function(resolve, reject) {
                        setTimeout(() => {
                            reject(new Error(walletConnectTimeOutMessage));
                        }, walletConnectTimeOut);

                        Vue.default.toasted.info(
                            walletConnectTrxNoticeMessage,
                            { duration: 2500 }
                        );

                        vaultContract.methods
                            .initWithdraw(withdrawAmount)
                            .send(param)
                            .on("transactionHash", async (txHash) => {
                                if(txHash) {
                                    while (true) {
                                        const trx = await context.rootState.wallet.activeWeb3.eth.getTransaction(txHash);
                                        // console.log(trx);
                                        if(trx && trx.blockNumber) {
                                            resolve(trx.blockNumber);
                                            break;
                                        }
                                    }
                                }
                            })
                            .on("receipt", async (receipt) => {
                                // console.log(receipt);
                                resolve(receipt.blockNumber);
                            })
                            .on("error", async (error, receipt) => {
                                // console.log(error);
                                reject(error);
                            });
                    });
                    return promise;
                } else {
                    const initWithdrawCall = await vaultContract.methods
                    .initWithdraw(withdrawAmount)
                    .send(param);

                    return initWithdrawCall;
                }
            } else {
                Vue.default.toasted.error(
                    "The vaults are currently closed for auction, and will be open for deposits and withdrawals once the winner deposits the winning premium."
                );
            }
        } catch (error) {
            if (error) {
                // except user denied
                if (error.code !== 4001 || error == undefined) {
                    //save some relevant data
                    const payload = {
                        message: error.message,
                        vault_contract,
                        amount,
                        abiType,
                        isEIP1559: type === undefined ? true : false,
                        maxWithdraw,
                        tokenSymbol: token ? token.symbol : null,
                        tokenDecimals: token ? token.decimals : null
                    };

                    await context.dispatch("logError", {
                        payload,
                        action: "INITWITHDRAW"
                    });
                }

                if (error.code === -32602) {
                    // let the view handle this error
                    throw error;
                }
            }

            if (error instanceof InitWithdrawException) {
                Vue.default.toasted.error(error.message);
            } else {
                if (error.message.includes("reverted"))
                    Vue.default.toasted.error(
                        error.message.split("reverted:")[1].split('"')[0]
                    );
                else
                    Vue.default.toasted.error(
                        "Error initiating withdrawal from vault"
                    );
            }

            return false;
        }
    },

    async cancelWithdraw(context, { vault_contract, abiType, type }) {
        //amount should be a string
        return await context.dispatch("initWithdraw", {
            vault_contract,
            amount: "0",
            abiType,
            type
        });
    },

    async deposit(
        context,
        { vault_contract, amount, abiType, maxDeposit, token, type }
    ) {
        try {
            if (+amount < 0) {
                throw new DepositToVaultException("Invalid deposit amount");
            }

            const vaultContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                window[abiType],
                vault_contract
            );

            let interaction = await context.dispatch("allowInteraction", {
                vault_contract,
                abiType
            });

            if (interaction == undefined || interaction == true) {
                let depositAmount = "0";
                // FYI cancelDeposit calls this function and the submitted amount is 0 and token will not be passed in
                if (token !== undefined && +amount > 0) {
                    // check deposit amount exceeds max deposit - currBalance returns a string
                    const currBalance = await context.dispatch(
                        "getVaultCurrentDeposit",
                        { vault_contract, token, is_divide: false }
                    );
                    if (currBalance === undefined) {
                        throw new DepositToVaultException(
                            "Could not retrieve current balance from vault"
                        );
                    }

                    Decimal.set({
                        precision: 50,
                        toExpPos: 50
                    });

                    const amountInBN = new Decimal(amount).mul(token.decimals);
                    const currBalanceInBN = new Decimal(currBalance);
                    const newBalanceInBN = currBalanceInBN.add(amountInBN);
                    const maxDepositInBN = new Decimal(maxDeposit).mul(
                        token.decimals
                    );

                    if (newBalanceInBN.gt(maxDepositInBN)) {
                        throw new DepositToVaultException(
                            "Deposit amount exceeds maximum allowable for this vault"
                        );
                    }

                    depositAmount = amountInBN.toString();
                }

                const data = vaultContract.methods
                    .deposit(depositAmount)
                    .encodeABI();

                const gasLimit = helpers.generateGasLimit(context.rootState.wallet.selectedNetwork);

                let param = {
                    to: vault_contract, // Required except during contract publications.
                    from: context.rootState.wallet.address, // must match user's active address.
                    gas: gasLimit, // customizable by user during MetaMask confirmation.
                    data: data, // Optional, but used for defining smart contract creation and interaction.
                    ...(type !== undefined && { type: type })
                };

                const gasFeeParam =  await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
                param = { ...param, ...gasFeeParam };

                await vaultContract.methods.deposit(depositAmount).call(param);

                // special case for walletconnect empty response
                if (context.rootState.wallet.walletProvider == "walletconnect") {
                    let promise = new Promise(function(resolve, reject) {
                        setTimeout(() => {
                            reject(new Error(walletConnectTimeOutMessage));
                        }, walletConnectTimeOut);

                        Vue.default.toasted.info(
                            walletConnectTrxNoticeMessage,
                            { duration: 2500 }
                        );

                        vaultContract.methods
                            .deposit(depositAmount)
                            .send(param)
                            .on("transactionHash", async (txHash) => {
                                if(txHash) {
                                    while (true) {
                                        const trx = await context.rootState.wallet.activeWeb3.eth.getTransaction(txHash);
                                        // console.log(trx);
                                        if(trx && trx.blockNumber) {
                                            resolve(trx.blockNumber);
                                            break;
                                        }
                                    }
                                }
                            })
                            .on("receipt", async (receipt) => {
                                // console.log(receipt);
                                resolve(receipt.blockNumber);
                            })
                            .on("error", async (error, receipt) => {
                                // console.log(error);
                                reject(error);
                            });
                    });
                    return promise;
                } else {
                    const approve = await vaultContract.methods
                        .deposit(depositAmount)
                        .send(param);

                    return approve;
                }
            } else {
                Vue.default.toasted.error(
                    "The vaults are currently closed for auction, and will be open for deposits and withdrawals once the winner deposits the winning premium."
                );
            }
        } catch (error) {
            console.log(error);
            if (error) {
                // except user denied
                if (error.code !== 4001 || error == undefined) {
                    //save some relevant data
                    const payload = {
                        message: error.message,
                        vault_contract,
                        amount,
                        abiType,
                        isEIP1559: type === undefined ? true : false,
                        maxDeposit,
                        tokenSymbol: token ? token.symbol : null,
                        tokenDecimals: token ? token.decimals : null
                    };

                    await context.dispatch("logError", {
                        payload,
                        action: "DEPOSIT"
                    });
                }

                if (error.code === -32602) {
                    // let the view handle this error
                    throw error;
                }
            }

            if (error instanceof DepositToVaultException) {
                Vue.default.toasted.error(error.message);
            } else {
                if (error.message.includes("reverted"))
                    Vue.default.toasted.error(
                        error.message.split("reverted:")[1].split('"')[0]
                    );
                else Vue.default.toasted.error("Error depositing to vault");
            }

            return false;
        }
    },

    async wrap(
        context,
        { token_contract, amount, abiType, maxWrap, token, type }
    ) {
        try {
            if (+amount < 0) {
                throw new DepositToVaultException("Invalid wrap amount");
            }

            const tokenContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                token.abi,
                token_contract
            );

            let wrapAmount = "0";
            // FYI cancelDeposit calls this function and the submitted amount is 0 and token will not be passed in
            if (token !== undefined && +amount > 0) {
                // check deposit amount exceeds max deposit - currBalance returns a string
                const currBalance = await context.dispatch(
                    "getVaultCurrentDeposit",
                    { token_contract, token, is_divide: false }
                );
                if (currBalance === undefined) {
                    throw new DepositToVaultException(
                        "Could not retrieve current balance from token"
                    );
                }

                Decimal.set({
                    precision: 50,
                    toExpPos: 50
                });

                const amountInBN = new Decimal(amount).mul(token.decimals);
                const currBalanceInBN = new Decimal(currBalance);
                const newBalanceInBN = currBalanceInBN.add(amountInBN);
                const maxWrapInBN = new Decimal(maxWrap).mul(token.decimals);

                if (newBalanceInBN.gt(maxWrapInBN)) {
                    throw new DepositToVaultException(
                        "Wrap amount exceeds maximum allowable for this token"
                    );
                }

                wrapAmount = amountInBN.toString();
            }

            let param = {
                to: token_contract, // Required except during contract publications.
                from: context.rootState.wallet.address, // must match user's active address.
                value: wrapAmount,
                ...(type !== undefined && { type: type })
            };

            const gasFeeParam = await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
            param = { ...param, ...gasFeeParam };

            // special case for walletconnect empty response
            if (context.rootState.wallet.walletProvider == "walletconnect") {
                let promise = new Promise(function(resolve, reject) {
                    setTimeout(() => {
                        reject(new Error(walletConnectTimeOutMessage));
                    }, walletConnectTimeOut);

                    Vue.default.toasted.info(
                        walletConnectTrxNoticeMessage,
                        { duration: 2500 }
                    );

                    tokenContract.methods
                        .deposit()
                        .send(param)
                        .on("transactionHash", async (txHash) => {
                            if(txHash) {
                                while (true) {
                                    const trx = await context.rootState.wallet.activeWeb3.eth.getTransaction(txHash);
                                    // console.log(trx);
                                    if(trx && trx.blockNumber) {
                                        resolve(trx.blockNumber);
                                        break;
                                    }
                                }
                            }
                        })
                        .on("receipt", async (receipt) => {
                            // console.log(receipt);
                            resolve(receipt.blockNumber);
                        })
                        .on("error", async (error, receipt) => {
                            // console.log(error);
                            reject(error);
                        });
                });
                return promise;
            } else {
                const approve = await tokenContract.methods.deposit().send(param);

                Vue.default.toasted.success("Token wrapped successfully");

                this.dispatch("wallet/getTokenBalance");

                return approve;
            }
        } catch (error) {
            if (error.code) {
                // user denied
                if (error.code !== 4001) {
                    //save some relevant data
                    const payload = {
                        message: error.message,
                        token_contract,
                        amount,
                        abiType,
                        isEIP1559: type === undefined ? true : false,
                        tokenSymbol: token ? token.symbol : null,
                        tokenDecimals: token ? token.decimals : null
                    };

                    await context.dispatch("logError", {
                        payload,
                        action: "WRAP"
                    });
                }

                if (error.code === -32602) {
                    // let the view handle this error
                    throw error;
                }
            }

            if (error instanceof DepositToVaultException) {
                Vue.default.toasted.error(error.message);
            } else {
                Vue.default.toasted.error("Transaction failed");
            }

            return false;
        }
    },

    // Cancle the Deposit while round is not started yet
    async cancelDeposit(context, { vault_contract, abiType, type }) {
        return await context.dispatch("deposit", {
            vault_contract,
            amount: 0,
            abiType,
            type
        });
    },

    async checkChainid() {
        // need to be checked
        return await ethereum.request({ method: "eth_chainId" });
    },

    async getVaultInfo(context, { vault_address, symbol, vault_network }) {
        try {
            const abi = context.state.ui_abi;

            const network = context.state.env.network[vault_network];
            const token = network.tokens.find(a => a.symbol == symbol);

            if (!context.rootState.wallet.walletProvider || !context.rootState.wallet.activeWeb3) return;
            const infoContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                abi,
                network.contract
            );

            const vaultInfo = await infoContract.methods
                .getVaultInfo(vault_address)
                .call({ from: context.rootState.wallet.address });

            let max_deposit;
            max_deposit = new Decimal(+vaultInfo.max_deposit)
                .dividedBy(token.decimals)
                .toNumber();
            // console.log('vaultinfo',vaultInfo,new Date(vaultInfo.expiry * 1000).toLocaleTimeString());
            // console.log('time',moment(vaultInfo.expiry * 1000).format('YYYY-MM-D h:mm:ss'))

            return {
                assetScaleX1e36: +vaultInfo.assetScaleX1e36 / 1e36,
                epoch: +vaultInfo.epoch,
                expiry: +vaultInfo.expiry,
                max_deposit: max_deposit,
                period: +vaultInfo.period,
                time_on_expiry: +vaultInfo.time_on_expiry,
                premiums_paid: vaultInfo.premium,
                total_asset: vaultInfo.total_asset,
                strike_price: vaultInfo.strike_price
            };
        } catch (error) {
            Vue.default.toasted.error("Failed to retrieve vault data");

            return false;
        }
    },

    async getMyPosition(context, { vault, decimals }) {
        try {
            // no need to get user position if user is on a different network from the vault's
            const currentNetwork = context.rootState.wallet.currentNetwork;
            if (
                vault === undefined ||
                currentNetwork === null ||
                vault.chain_id !== currentNetwork.chain ||
                !context.rootState.wallet.walletProvider
            ) {
                return {
                    queuedDeposits: 0,
                    position: 0,
                    activeDeposit: "0",
                    queuedWithdraw: 0,
                    userScaleX1e36: 0,
                    queuedEpoch: 0,
                    exitQueueEpoch: 0,
                    balance: 0,
                    deposit: 0,
                    depositString: "0",
                    exitToken: 0,
                    maxWithdraw: 0,
                    premiumRealised: 0,
                    totalBalance: 0,
                    pendingWithdrawal: 0,
                };
            }

            const network = context.state.env.network[vault.network];
            const infoContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                context.state.ui_abi,
                network.contract
            );

            let mvp = await infoContract.methods.myVaultPosition(vault.contract_address).call({ from: context.rootState.wallet.address });
            const gvi = await infoContract.methods.getVaultInfo(vault.contract_address).call({ from: context.rootState.wallet.address });
            // console.table(mvp);
            // console.table(gvi);

            Decimal.set({
                precision: 50,
                toExpPos: 50
            });

            const userHasPendingWdOnPrevRound = +mvp[5] <= +gvi.epoch && +mvp[5] != 0;

            let BalancePlusExitAmount = new Decimal(mvp[6]);
            if(+mvp[4] > +gvi.epoch ) BalancePlusExitAmount = BalancePlusExitAmount.minus(mvp[0]); // conditions where user has pending deposit for next round
            if(userHasPendingWdOnPrevRound) {
                // user has pending withdrawal on previous round
                BalancePlusExitAmount = new Decimal(mvp[7]);
                mvp[1] = mvp[7];
            }

            let myBalWithPremium = BalancePlusExitAmount.mul(1 + +gvi.premium / +gvi.total_asset);
            let activeDeposit = new Decimal(mvp[1]);
            let queuedDeposits = new Decimal(mvp[0]);
            let queuedEpoch = +mvp[4];
            let queuedWithdraw = mvp[2]/decimals;

            if(+mvp[5] == +gvi.epoch && +gvi.expiry > 0){
                // withdrawal is current round and not expired
                queuedWithdraw = new Decimal(mvp[6]).minus(mvp[7]).div(decimals);
                // queuedWithdraw = queuedWithdraw * (1 + gvi.premium / gvi.total_asset);
            }else if(+mvp[5] > +gvi.epoch && +gvi.expiry == 0){
                // round is expired
                queuedWithdraw = new Decimal(mvp[6]).minus(mvp[7]).div(decimals);
            }

            if (+queuedEpoch <= +gvi.epoch) {
                activeDeposit = activeDeposit.plus(queuedDeposits);
                queuedDeposits = 0;
            } else queuedDeposits = queuedDeposits.div(decimals).toString();

            //active deposit for il vaults
            if (vault.is_il == 1) {
                activeDeposit = new Decimal(mvp[3]);
                if (+mvp[5] == +gvi.epoch) {
                    activeDeposit.plus(mvp[4]);
                }
            }

            //premium calculation
            let premiumRealised = 0;
            let totalBalance = 0;
            let pendingWithdrawal = 0;
            let maxWithdraw = new Decimal(myBalWithPremium).minus(mvp[2]);

            if (gvi.expiry != 0) {
                //===round is running || ended without settlement===
                premiumRealised = myBalWithPremium - activeDeposit;
                totalBalance = myBalWithPremium;
                //get premium percentage based on queueWithdraw
                if(+mvp[2] > 0){
                    const premiumPercentage = mvp[2] / mvp[6] * premiumRealised;
                    pendingWithdrawal = new Decimal(mvp[2]).plus(premiumPercentage);
                }
                // if(+mvp[2] > 0) premiumRealised = premiumRealised - premiumPercentage;
            } else {
                //==round ended with settlement==

                premiumRealised = new Decimal(BalancePlusExitAmount).minus(activeDeposit);
                totalBalance = new Decimal(activeDeposit).plus(premiumRealised);
                pendingWithdrawal = new Decimal(mvp[6]).minus(mvp[7]);
                maxWithdraw = totalBalance;
            }

            if (userHasPendingWdOnPrevRound) {
                pendingWithdrawal = new Decimal(mvp[6]).minus(mvp[7]);
            }

            // calcation for IL vaults max withdrawal
            let maxWithdrawIL = new Decimal(mvp[6]);
            if (+queuedEpoch > +gvi.epoch) {
                maxWithdrawIL = maxWithdrawIL.minus(queuedDeposits);
            }

            //find reverse token
            const reverse_token = network.tokens.find(
                a => a.symbol == vault.reverse_token_symbol
            );

            return {
                queuedDeposits: queuedDeposits,
                position: +mvp[1] / decimals,
                activeDeposit: activeDeposit.div(decimals).toString(),
                queuedWithdraw: queuedWithdraw,
                userScaleX1e36: +mvp[3] / 1e36,
                queuedEpoch: queuedEpoch,
                exitQueueEpoch: +mvp[5],
                balance: +mvp[6],
                deposit: +mvp[7],
                depositString: mvp[7],
                maxWithdrawIL: maxWithdrawIL.div(decimals).toString(),
                exitToken: +mvp[4] / reverse_token.decimals,

                //new formula
                maxWithdraw: (maxWithdraw/decimals).toFixed(helpers.countDecimals(new Decimal(decimals).toString())),
                premiumRealised: premiumRealised/decimals,
                totalBalance: (totalBalance/decimals).toFixed(helpers.countDecimals(new Decimal(decimals).toString())),
                pendingWithdrawal: pendingWithdrawal/decimals
            };
        } catch (error) {
            console.log('er',error);
            Vue.default.toasted.error("Failed to retrieve vault data");

            return false;
        }
    },

    async initRound(
        context,
        {
            contract_address,
            strike_price,
            premium_price,
            vault_min_size,
            contract_type
        }
    ) {
        const vaultContract = new context.rootState.wallet.activeWeb3.eth.Contract(
            window[contract_type],
            contract_address
        );

        let roundStrikeX1e6 = context.rootState.wallet.activeWeb3.utils.toBN(
            strike_price * 1e6
        );
        let premium = context.rootState.wallet.activeWeb3.utils.toBN(
            premium_price * 1e18
        );
        if (contract_type == "put_selling") {
            premium = context.rootState.wallet.activeWeb3.utils.toBN(
                premium_price * 1e4
            );
        }
        let vaul_min_sizeBN = context.rootState.wallet.activeWeb3.utils.toBN(
            vault_min_size
        );
        const data = vaultContract.methods
            .initNewRound(roundStrikeX1e6, premium, vaul_min_sizeBN)
            .encodeABI();

        //const gasLimit = helpers.generateGasLimit(context.rootState.wallet.selectedNetwork);

        let transactionParameters = {
            nonce: "0x00", // ignored by MetaMask
            gas: "250000", // customizable by user during MetaMask confirmation.
            to: contract_address, // Required except during contract publications.
            from: context.rootState.wallet.address, // must match user's active address.
            data: data, // Optional, but used for defining smart contract creation and interaction.
            chainId: "0x4" // Used to prevent transaction reuse across blockchains. Auto-filled by MetaMask.
        };

        const gasFeeParam =  await context.dispatch("generateGasFee", context.rootState.wallet.selectedNetwork);
        transactionParameters = { ...transactionParameters, ...gasFeeParam };

        const txHash = await ethereum
            .request({
                method: "eth_sendTransaction",
                params: [transactionParameters]
            })
            .then(txHash => {
                return txHash;
            })
            .catch(error => error);

        return txHash;
    },

    async getVaultCurrentDeposit(
        context,
        { vault_contract, token, vault, is_divide = true }
    ) {
        const vault_value = vault?.vault_detail
            ? vault.vault_detail.total_vault_value +
            vault.vault_detail.total_profit
            : 0;
        if (vault) {
            // to prevent errors when user is on a different network from the vault's
            const currentNetwork = context.rootState.wallet.currentNetwork;
            // if wallet not connected then return value from db
            if (
                !context.rootState.wallet.walletProvider ||
                currentNetwork === null ||
                vault.chain_id !== currentNetwork.chain
            )
                return vault_value;

            const tokenContract = new context.rootState.wallet.activeWeb3.eth.Contract(
                token.abi,
                token.contract
            );

            let currBalance = await tokenContract.methods
                .balanceOf(vault_contract)
                .call();

            if (currBalance && is_divide) {
                currBalance /= token.decimals;
            }

            return currBalance;
        } else {
            return vault_value;
        }
    },

    async logError(context, { payload, action }) {
        await axios.post("/api/log-error", {
            action,
            data: JSON.stringify(payload)
        });
    }
};

const mutations = {
    setVaultEnv(state, value) {
        state.network = value.vault_network;
        state.env = value;
    },

    setShowNetworkAlert(state, showNetworkAlert) {
        state.showNetworkAlert = showNetworkAlert;
    },

    setVaults(state, vaults) {
        state.vaults = vaults;
    },

    setVault(state, { contract, info }) {
        state.vaults[contract] = info;
    },

    updateVault(state, { vaultInfo, contract_address }) {
        let index = state.vaults.findIndex(element => {
            if (element.contract_address === contract_address) {
                return true;
            }
        });

        state.vaults[index] = {
            ...state.vaults[index],
            ...vaultInfo
        };
    },

    setUiAbi(state, ui_abi) {
        state.ui_abi = ui_abi;
    },
    setSynAbi(state, syn_abi) {
        state.syn_abi = syn_abi;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
